const BLOGS_PATHS = ['/blog', '/learn'];

export const isSigningUpFromBlog = () => {
  const referrer = document ? document.referrer : '';
  const isReferrerFromBlog = BLOGS_PATHS.some(path => referrer.includes(path));

  return isReferrerFromBlog;
};
